import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideRouter, RouterOutlet, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideQueryClientOptions } from '@ngneat/query';
import { authInterceptor, provideAuth } from '@sona/angular-auth-domain';
import { SonaIconComponent } from '@sona/angular-ui-components';
import { provideFooterItems } from '@sona/angular-ui-components/app-footer';
import { provideAnalytics } from '@sona/angular-util-analytics';
import { languageInterceptor } from '@sona/angular-util-common';
import { SonaEnvironmentModule } from '@sona/angular-util-environment';
import { errorInterceptor } from '@sona/angular-util-errors';
import { Featurebase } from '@sona/angular-featurebase';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { HlmToasterComponent } from '@spartan-ng/ui-sonner-helm';
import { IntlModule } from 'angular-ecmascript-intl';

import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { apiInterceptor } from './interceptors/api.interceptor';
import { APP_ROUTES } from './routing/app.routes';
import { AppSentryModule } from './sentry/sentry.module';
import { AppStateModule } from './state/state.module';
import { provideTranslations } from './translations';

const API_SEGMENT = '/api';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        AppStateModule,
        environment.production ? AppSentryModule : [],
        IntlModule,
        RouterOutlet,

        SonaEnvironmentModule.forRoot(environment),
        HlmToasterComponent,
        ServiceWorkerModule.register('./notifications-worker.js', {
            enabled: true,
            registrationStrategy: 'registerWhenStable:30000'
        }),
        HlmButtonDirective,
        SonaIconComponent
    ],
    providers: [
        provideRouter(APP_ROUTES, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always'})),
        provideAnalytics(environment.analytics),
        provideQueryClientOptions({
            defaultOptions: {
                queries: {
                    retryDelay: (attemptIndex) =>
                        Math.min(1000 * 2 ** attemptIndex, 30000)
                }
            }
        }),
        provideHttpClient(
            withInterceptors([
                languageInterceptor(API_SEGMENT),
                authInterceptor(API_SEGMENT),
                errorInterceptor(API_SEGMENT),
                apiInterceptor(API_SEGMENT)
            ])
        ),
        provideTranslations(),
        provideAuth(environment.auth),
        provideFooterItems([
            { label: 'FOOTER.IMPRINT', link: '/imprint' },
            { label: 'FOOTER.PRIVACY', link: '/privacy' },
            { label: 'FOOTER.TERMS', link: '/terms' }
        ]),
        environment.featurebase.appId ? Featurebase : { provide: Featurebase, useValue: null }
    ],
    declarations: [ AppComponent ],
    bootstrap: [ AppComponent ]
})
export class AppModule {}
